const modifySubmissionFunder = function (
  { commit, dispatch },
  { id, field, value }
) {
  commit("UPDATE_SUBMISSION_FUNDER", { id, field, value });
  dispatch("validateSubmission");
};

export default modifySubmissionFunder;
